import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
// Security hardening verified: 2026-02-07


const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Messaging safely
let messaging = null;
try {
    if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
        messaging = getMessaging(app);
    } else {
        console.warn('Firebase Messaging not supported (ServiceWorker missing).');
    }
} catch (error) {
    console.warn('Failed to initialize Firebase Messaging:', error);
}

export { messaging };

// VAPID Key (Web Push Certificate)
export const VAPID_KEY = import.meta.env.VITE_FIREBASE_VAPID_KEY;
